module.exports = __webpack_public_path__ + "img/time.20ee3821.png";